// src/components/NotFound.js

import React from "react";
import { Box, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

function NotFound() {
  const navigate = useNavigate();

  return (
    <Box p={3} textAlign="center">
      <Typography variant="h4" gutterBottom>
        404 - Página Não Encontrada
      </Typography>
      <Button
        variant="contained"
        color="primary"
        onClick={() => navigate("/user/home")}
        sx={{ marginTop: 2 }}
      >
        Voltar para a Página Principal
      </Button>
    </Box>
  );
}

export default NotFound;
